import React, { useEffect } from 'react';
import { UnorderedList } from '@Components/unordered_list/view';
import axios from 'axios';
import s from '../styles/Selling.module.css';
import tabPanel from '../styles/TabPanel.module.css';
import { cleanCourseName } from '@Util/util';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';

type SellingProps = {
    show: boolean;
    courseId: number;
    courseName: string; // courseNameを追加
    children: React.ReactNode;
};
export const Selling = (props: SellingProps) => {
    const [flows, setFlows] = React.useState([]);
    const [corporateMemberDocuments, setCorporateMemberDocuments] = React.useState([]);
    const [individualDocuments, setIndividualDocuments] = React.useState([]);
    const [allTargetDocuments, setAllTargetDocuments] = React.useState([]);
    const displayDocuments =
        corporateMemberDocuments.length + individualDocuments.length + allTargetDocuments.length > 0;

    // 非アクティブなタブもDOMに残すため、表示前からマウントされる。
    // 初期表示で不要なリクエストを出さないよう、最初に表示されたときだけ取得する。
    // 失敗した場合はフラグを戻し、次にタブを開いたときに再取得できるようにする
    const hasFetched = React.useRef(false);

    useEffect(() => {
        if (!props.show || hasFetched.current) return;
        hasFetched.current = true;

        const onError = () => {
            hasFetched.current = false;
        };

        axios
            .get(`/api/v1/courses/${props.courseId}/membership_transfer_process_flows`)
            .then((res) => setFlows(res.data.flows))
            .catch(onError);
        axios
            .get(`/api/v1/courses/${props.courseId}/membership_transfer_documents`)
            .then((res) => {
                const documents = res.data.documents;
                setCorporateMemberDocuments(documents.filter((v) => v.target === 'corporation'));
                setIndividualDocuments(documents.filter((v) => v.target === 'individual'));
                setAllTargetDocuments(documents.filter((v) => v.target === 'all_target'));
            })
            .catch(onError);
    }, [props.show]);

    return (
        <div className={`${s.container} ${props.show ? '' : tabPanel.tab_panel_hidden}`}>
            <Heading2 title={`${cleanCourseName(props.courseName)}の会員権売却価格`} />
            <div className={s.section_body}>{props.children}</div>

            {flows.length ? (
                <>
                    <Heading2 title={`${cleanCourseName(props.courseName)}退会の流れ`} />
                    <div className={s.head_2_body}>
                        {flows.map((flow) => (
                            <p className={s.selling_step} key={flow.order}>
                                {flow.order}. {flow.description}
                            </p>
                        ))}
                    </div>
                </>
            ) : (
                ''
            )}

            {displayDocuments ? (
                <>
                    <Heading2 title={`${cleanCourseName(props.courseName)}退会の必要書類`} />
                    <div className={s.head_2_body}>
                        <div className={s.document_without_h3}>
                            <UnorderedList items={allTargetDocuments} />
                        </div>
                        {individualDocuments.length > 0 && (
                            <>
                                <Heading3 title={'個人会員の場合に必要な書類'} />
                                <div className={s.head_3_body}>
                                    <UnorderedList items={individualDocuments} />
                                </div>
                            </>
                        )}
                        {corporateMemberDocuments.length > 0 && (
                            <>
                                <Heading3 title={'法人会員の場合に必要な書類'} />
                                <div className={s.head_3_body}>
                                    <UnorderedList items={corporateMemberDocuments} />
                                </div>
                            </>
                        )}
                    </div>
                </>
            ) : (
                ''
            )}
        </div>
    );
};

export default Selling;
